import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './VerifyCode.css';
import config from '../config/config';

const checkVerifyCode = `${config.apiUrl1}/api/verification-codes/verify-code`;
const restartVerifyCode = `${config.apiUrl1}/api/verification-codes/verify-code-restart`;

function VerifyCode({ onClose, onVerified }) {
    const [code, setCode] = useState('');
    const [statusMessage, setStatusMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [attempts, setAttempts] = useState(0);

    const navigate = useNavigate();
    const location = useLocation();
    const { userId, phone, flag } = location.state || {};

    const handleVerify = async () => {
        if (!code) {
            setStatusMessage('Введите код');
            return;
        }

        setLoading(true);
        setStatusMessage('');

        try {
            const response = await fetch(checkVerifyCode, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ phone, verifyCode: Number(code) }),
            });

            const verified = await response.json();

            if (!response.ok) {
                setStatusMessage('Ошибка сервера');
            } else if (verified === true) {
                localStorage.setItem('phoneNumber', phone);
                localStorage.setItem('userId_createdAt', new Date().toISOString());
                localStorage.setItem('userId', userId);
                setStatusMessage('✅ Код подтверждён');
                setTimeout(() => {
                    if (onVerified) onVerified();
                    if (onClose) onClose();
                    if (flag === 'profile') navigate('/profile-page');
                    else if (flag === 'application') navigate('/application-form');
                    else navigate('/');
                }, 500);
            } else {
                setAttempts(prev => prev + 1);
                if (attempts === 0) {
                    setStatusMessage('❌ Код неверный. Попробуйте ещё раз.');
                } else {
                    setStatusMessage('❌ Код неверный. Вы будете перенаправлены.');
                    setTimeout(() => navigate('/'), 2000);
                }
            }
        } catch {
            setStatusMessage('Сетевая ошибка');
        } finally {
            setLoading(false);
        }
    };

    const handleResend = async () => {
        setLoading(true);
        setStatusMessage('⏳ Отправляем новый код...');

        try {
            const response = await fetch(restartVerifyCode, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'User-Agent': 'insomnia/11.3.0',
                },
                body: JSON.stringify({ phone }),
            });

            if (!response.ok) {
                setStatusMessage('❌ Ошибка при отправке нового кода');
            } else {
                setStatusMessage('📲 Новый код отправлен на телефон');
                setCode('');
            }
        } catch {
            setStatusMessage('❌ Сетевая ошибка при отправке кода');
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => navigate('/');

    return (
        <div className="modal-overlay2">
            <div className="modal2">
                <button className="close-icon2" onClick={handleClose}>×</button>
                <h2>Подтверждение</h2>
                <p>Код отправлен на: <strong>{phone}</strong></p>

                <input
                    className="input2"
                    type="text"
                    value={code}
                    onChange={e => setCode(e.target.value)}
                    placeholder="Введите код"
                />

                <button className="verify-btn2" onClick={handleVerify} disabled={loading}>
                    {loading ? 'Проверяем...' : 'Подтвердить'}
                </button>

                {statusMessage && <p className="status2">{statusMessage}</p>}

                {attempts === 1 && (
                    <button className="resend-btn2" onClick={handleResend} disabled={loading}>
                        {loading ? 'Отправляем...' : 'Переотправить код'}
                    </button>
                )}
            </div>
        </div>
    );
}

export default VerifyCode;
